<template>
  <div class="login">
    <div class="row m-0">
      <div class="col-md-8 pl-0 bg-colr">
        <div class="backg-img">
          <div id="img-whole"></div>
        </div>
      </div>

      <div class="col-md-4 bg-colr">
        <div class="wrap-600">
          <div class="logo-img text-center">
            <img src="../assets/img/airbuddy-logo.png" alt="logo-img" width="50%" />
          </div>
          <div class="all-login">
            <div id="login">
              <form @submit.prevent="login">
                <div class="form-group">
                  <input
                    type="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter email"
                    name="email"
                    v-model="userlog.email"
                  />
                  <span class="invalid" v-if="loginemailError">{{this.loginemailErrorMsg}}</span>
                  <small
                    id="emailHelp"
                    class="form-text text-muted"
                  >Never share your email with anyone else.</small>
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    name="password"
                    v-model="userlog.password"
                  />
                  <span class="invalid" v-if="loginpasswordError">{{this.loginpasswordErrorMsg}}</span>
                </div>
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="exampleCheck1" />
                  <label class="form-check-label" for="exampleCheck1">Remember me</label>
                </div>

                <button type="submit" class="btn btn-primary">Login</button>
                <div class="spinnerss">
                  <pulse-loader :loading="loading"></pulse-loader>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
export default {
  components: {
    PulseLoader
  },
  data() {
    return {
      loading: false,
      loginemailError: false,
      loginpasswordError: false,
      userlog: {
        email: "",
        password: "",
        remember: false
      }
    };
  },
  computed: {},
  methods: {
    login() {
      (this.loading = true),
        this.axios
          .post("/login-admin", this.userlog)
          .then(response => {
            console.log(response);
            this.successLogin(response);
          })
          .catch(error => {
            console.log(error);
          });
    },
    successLogin(response) {
      if (response.data.status == "error") {
        if (response.data.field == "email") {
          this.loginemailError = true;
          this.loginemailErrorMsg = response.data.message;
        } else if (response.data.field == "password") {
          this.loginpasswordError = true;
          this.loginpasswordErrorMsg = response.data.message;
        }
      } else if (response.data.status == "verify") {
        this.userlog.email = "";
        this.userlog.password = "";
        this.userlog.remember = false;
      } else if (response.data.status == "lock") {
        this.userlog.email = "";
        this.userlog.password = "";
        this.userlog.remember = false;
      } else {
        this.$auth.settokenAdmin(
          response.data.access_token,
          response.data.expires_in + Date.now()
        );
        this.userlog.email = "";
        this.userlog.password = "";
        this.userlog.remember = false;
        this.$router.push("/dashboard");
        window.location.reload();
      }
      this.loading = false;
    }
  }
};
</script>

<style>
@import "../assets/scss/our-scss/login.scss";
</style>